export const DELIVERY_ADDRESS_NOT_FOUND = 'delivery_address_not_found';
export const INVALID_DATE = 'invalid_date';
export const RESTAURANT_CANNOT_ACCEPT_ORDERS = 'restaurant_cannot_accept_orders';
export const DISABLED_MEAL = 'disabled_meal';
export const CORRUPTED_BASKET = 'corrupted_basket';



// WEBPACK FOOTER //
// ./constants/errorCodes.js